const projects = [
  {
    id: 1,
    title: "Cover Letter AI",
    image: "/assets/images/projects/cover_letter_ai.png",
    url: "https://cover-letter-llm.vercel.app/",
    alt: "Cover Letter AI"
  },
  {
    id: 2,
    title: "The Daily Crumb",
    image: "/assets/images/projects/dailycrumb_275_200.jpg",
    url: "https://github.com/uyonoh/DailyCrumb",
    alt: "The Daily Crumb"
  },
  {
    id: 3,
    title: "MediTrack",
    image: "/assets/images/projects/meditrack_322x200.jpg",
    url: "https://github.com/uyonoh/MediTrack",
    alt: "MediTrack pharmacy dashboard"
  },
  {
    id: 4,
    title: "Tech Nexus Eccommerce",
    image: "/assets/images/projects/nexus.png",
    url: "https://github.com/uyonoh/Nexus",
    alt: "Tech Nexus Eccomerce Platform"
  },
  {
    id: 5,
    title: "AI Flow",
    image: "/assets/images/projects/Ai_flow_429x200.jpg",
    url: null,
    alt: "AI Flow"
  },
  {
    id: 6,
    title: "More from me...",
    image: "/assets/images/logos/github.png",
    url: "https://github.com/uyonoh",
    alt: "Git Hub"
  }
];

const technologies = [
  {
    name: "Python",
    iconClass: "python-original",
    type: "image",
    src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg",
    delay: "0"
  },
  {
    name: "TensorFlow",
    iconClass: "devicon-tensorflow-original colored",
    type: "icon",
    delay: "200"
  },
  {
    name: "PyTorch",
    iconClass: "devicon-pytorch-original colored",
    type: "icon",
    delay: "300"
  },
  {
    name: "Selenium",
    iconClass: "devicon-selenium-original colored",
    type: "icon",
    delay: "400"
  },
  {
    name: "Django",
    iconClass: "devicon-django-plain colored",
    type: "icon",
    delay: "500"
  },
  {
    name: "React",
    iconClass: "devicon-react-original colored",
    type: "icon",
    delay: "600"
  },
  {
    name: "Next.js",
    iconClass: "devicon-nextjs-plain colored",
    type: "icon",
    delay: "700"
  },
  {
    name: "Vite",
    iconClass: "devicon-vite-plain colored",
    type: "icon",
    delay: "700"
  },
  {
    name: "Bootstrap",
    iconClass: "devicon-bootstrap-plain colored",
    type: "icon",
    delay: "800"
  },
  {
    name: "Tailwind",
    iconClass: "devicon-tailwindcss-original colored",
    type: "icon",
    delay: "900"
  },
  {
    name: "FastAPI",
    iconClass: "devicon-fastapi-plain colored",
    type: "icon",
    delay: "1000"
  },
  {
    name: "JavaScript",
    iconClass: "devicon-javascript-plain colored",
    type: "icon",
    delay: "1100"
  },
  {
    name: "TypeScript",
    iconClass: "devicon-typescript-plain colored",
    type: "icon",
    delay: "1200"
  },
  {
    name: "C",
    iconClass: "devicon-c-plain colored",
    type: "icon",
    delay: "1300"
  }
];

export { projects, technologies }